import { render, staticRenderFns } from "./default-table.vue?vue&type=template&id=6d2898b8"
import script from "./default-table.vue?vue&type=script&lang=js"
export * from "./default-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports